import React, { useEffect, useState } from "react";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import { useTemplateContext } from "../../../context/TemplateContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import GoogleDocTemplateEditor from "./GoogleDocTemplateEditor";

const GoogleDocTemplateViewer = ({ file }) => {
  const { templateData, setTemplateData } = useTemplateContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTemplate = async () => {
    try {
      setIsLoading(true);
      const res = await axiosInstance.get(`/googledoc/${file.id}`);
      setTemplateData(res.data);
    } catch (err) {
      setError("Failed to load Google Doc template.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }
  if (!templateData) return null;

  return <GoogleDocTemplateEditor file={file} templateData={templateData} setTemplateData={setTemplateData} />;
};

export default GoogleDocTemplateViewer;
